import { useTheme } from '@mui/material';

const hexToRGBA = (hex: string, opacity: number) => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const getBackgroundColor = (color: string, opacity = 0.12) => {
  const theme = useTheme();
  if (color.startsWith('#')) return hexToRGBA(color, opacity);
  try {
    const themeColor = theme.palette[color as keyof typeof theme.palette];
    if (typeof themeColor === 'string') {
      return hexToRGBA(themeColor, opacity);
    } else if (
      themeColor &&
      typeof themeColor === 'object' &&
      'main' in themeColor
    ) {
      return hexToRGBA(themeColor.main, opacity);
    }
  } catch (error) {
    console.error('Error getting theme color:', error);
  }
  return hexToRGBA(theme.palette.primary.main, opacity);
};
